import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../services/user/user.service';
import {NotificationService} from '../../../services/common/notification.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-reset-token',
  templateUrl: './reset-token.component.html',
  styleUrls: ['./reset-token.component.scss'],
  standalone: false
})
export class ResetTokenComponent implements OnInit {

  resetPasswordForm: UntypedFormGroup;
  hideNewPw = true;
  hideCurrentPw = true;
  token: string;

  constructor(private _formBuilder: UntypedFormBuilder,
              private userService: UserService,
              private notificationService: NotificationService,
              private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required]],
      newPasswordRepeated: ['', [Validators.required]],
    });
  }

  changePassword() {
    if (this.resetPasswordForm.valid) {
      this.userService.resetPasswordWithToken(this.resetPasswordForm.get('newPassword').value, this.token).subscribe(() => {
        this.notificationService.openSnackBar('Passwort wurde zurückgesetzt.');
      }, error => {
        this.notificationService.openSnackBar(error);
      });
    }
  }

}
